import React from "react";
import { Box, TextField, TextFieldProps, Typography } from "@mui/material";
import { PRIMARY_SILVER_COLOR } from "..";

type Props = TextFieldProps & {
  label?: React.ReactNode;
  wrapperStyles?: React.CSSProperties;
  labelStyles?: React.CSSProperties;
};

export const CustomTextInput = React.forwardRef<HTMLInputElement, Props>(
  ({ label, id, wrapperStyles, labelStyles, ...rest }, ref) => {
    const inputId = id ?? rest?.name;

    return (
      <Box sx={wrapperStyles}>
        {label && (
          <Typography
            component="label"
            variant="caption"
            htmlFor={inputId}
            sx={{
              fontSize: "13px", // to match legacy design
              color: PRIMARY_SILVER_COLOR[500],
              ...labelStyles,
            }}
          >
            {label}
          </Typography>
        )}

        <TextField
          id={inputId}
          variant="outlined"
          fullWidth
          inputRef={ref}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 0, // Remove border radius
            },
            ...rest.sx,
          }}
          {...rest}
        />
      </Box>
    );
  }
);

CustomTextInput.displayName = "CustomTextInput";
